export const accounting = {
    methods: {
        _calculateVat(cost, price, margin, rate = 1.22) {

            cost = parseFloat(cost)
            price = parseFloat(price)
            rate = parseFloat(rate)

            if (margin) {
                return ((price - cost) / rate - (price - cost)) * -1
            }

            return (price / rate - price) * -1
        },
        _calculateGain(cost, price, vat, extra = 0) {

            cost = parseFloat(cost)
            price = parseFloat(price)
            vat = parseFloat(vat)
            extra = parseFloat(extra)

            return price - vat - cost - extra
        },
        _calculateDilapayCost(price, rates, advance = 0) {

            price = parseFloat(price)
            rates = parseFloat(rates)
            advance = parseFloat(advance)

            const base = price - advance
            const fixed = rates * 0.6
            const variable = base * 2.9 / 100

            return (fixed + variable).toFixed(2)

        },
        _calculatePosCost(price, kind) {

            price = parseFloat(price)

            if (kind === 'Bancomat') {
                return (price * 0.5 / 100).toFixed(2)
            }

            return (price * 1.1 / 100).toFixed(2)
        }
    }
}